export enum ErrorCode {
    Unknown,

    // BinanceOptionsSecuredDataService = 100
    BinanceUnknown = 101,
    BinanceUnauthorized = 102,
    BinanceInvalidPriceMultiplicity = 103,
    BinancePriceLessThanOrEqualToZero = 104,
    BinanceInvalidSizeMultiplicity = 105,
    BinanceApiKeyEmpty = 106,
    BinanceTimestampLessThanOrEqualToZero = 107,
    BinanceReceiveWindowLessThanOrEqualToZero = 108,
    BinanceSignatureEmpty = 109,
    BinanceSymbolEmpty = 110,
    BinanceOrderIdLessThanOrEqualToZero = 111,
    BinanceInternalOrderIdIsNull = 112,
    BinanceInternalOrderIdLessThanOrEqualToZero = 113,
    BinanceSizeEqualZero = 114,
    BinanceInvalidOrderType = 115,
    BinanceInvalidOrderSide = 116,
    BinanceApiKeyIsNull = 117,
    BinanceSecretKeyIsNull = 118,

    // PortfolioInfo = 200
    PortfolioItemIdLessThanOrEqualToZero = 201,
    AutoOrderConfigurationRequired = 202,
    AutoOrderConfigurationPortfolioItemIdMismatch = 203,
    AutoOrderStrategyUnsupported = 204,
    AutoOrderTargetPriceLessThanOrEqualToZero = 205,
    AutoOrderMaxImpliedVolatilityLevelLessThanOrEqualToZero = 206,
    AutoOrderMaxPriceDeltaLessThanOrEqualToZero = 207,
}
